
import { React, useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../main-page.css'
import Button from 'react-bootstrap/Button';
import { Row, Col, Offcanvas } from 'react-bootstrap';
import { FaLongArrowAltRight } from "react-icons/fa";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { CgMenuGridO } from "react-icons/cg";
import { RiGalleryLine } from "react-icons/ri";
import { FaChartArea } from "react-icons/fa";
import { GrStatusUnknown } from "react-icons/gr";
import Carousel from 'react-bootstrap/Carousel';
import NewsTicker from "./newsticker";
import { TiSocialFacebook } from "react-icons/ti";
import { FaTwitter } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";



function Contact(){
  const [show, setShow] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);

  };
  const [isPaused, setIsPaused] = useState(false);

  const handleMouseEnter1 = () => {
    setIsPaused(true);
  };

  const handleMouseLeave1 = () => {
    setIsPaused(false);
  };
  const newsItems = [
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
  ];


  return (
    <>
      <Navbar expand="lg" className='main-navbar fixed-top'  style={{boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px'}}>
        <Container fluid className='p-0'>
          <Navbar.Brand href="#home" className='d-flex align-items-center'>
            <a class="navbar-brand  d-flex align-items-center ms-2 ms-md-4" href="#">
            <img src="../images/apslogo.webp" alt="aps" className="img-fluid" />
            <div className="brand-text ms-2 text-left">
              <p className="brand-title">AndhraPradesh State<br></br><span>Housing</span> Corporation Limited</p>
            </div>
          <img src="../images/aplogo.webp" alt="Logo" className="img-fluid" />
          </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"  className="border-0"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className='' href="/">Home</Nav.Link>
              <Nav.Link className='' href="/About">About</Nav.Link>
              <Nav.Link className='' href="/DashBoard">Dashboard</Nav.Link>
              <Nav.Link className='' href="/organogram">Organogram</Nav.Link>
              <Nav.Link className='' href="/donation">Donation</Nav.Link>
              <Nav.Link className='active' href="/Contact">Contact Us</Nav.Link>
            </Nav>
                <Button onClick={handleShow} className="menu-btn"><CgMenuGridO style={{ fontSize: '35px' }} />
                </Button>
                <Offcanvas show={show} onHide={handleClose} placement="end" className='main-off'>
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav defaultActiveKey="/home" className="side-nav">
                      <Nav.Link href="/home">Gallery</Nav.Link>
                      <Nav.Link  href="/organogram"  eventKey="link-1">Organogram</Nav.Link>
                      <Nav.Link eventKey="link-2">Whos is who</Nav.Link>
                      <Nav.Link  href="/contact"  eventKey="link-2">Contact US</Nav.Link>
                    </Nav>
                  </Offcanvas.Body>
                </Offcanvas>
          </Navbar.Collapse>
        </Container>
      </Navbar>
{/*---------------Welcome----------------------*/}
<section className="cm-min-images position-relative">
<img src='../images/blueprint.webp' className="img-fluid blueprint-shape"/>
<Container className="schemes-contain d-block">
 <Row>
 <Col xs={12} sm={12} md={0} lg={2} xl={2} xxl={2} className="my-auto"></Col>
 <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="my-auto schemes">
 <h2><span className="houseing-text">Contact</span> <br />APSHCL</h2>
 </Col>
    <Col xs={12} sm={12} lg={6} md={8} xl={6} xxl={6} className="Welcome-part mt-5 pt-5 mt-lg-none">
    <div className="footer-content mt-5 pt-4">
   <h5 style={{textDecoration:'underline'}}>Address</h5>
   <p className="adsress-text">AP State Housing Corporation<br></br>Plot No : 11 & 12 Behind BSNL,<br></br>Telephone Exchange Auto Nagar,<br></br>Vijayawada, Andhra Pradesh- 520007.</p> 
   <div className="footer-content">
  <div className="phone d-flex">
  <img src="../images/phone.webp" className="phone-img"/>
  <div className="phone-text">
  <h6>Toll free Number</h6>
  <p className="mb-0">08663501300</p>
  </div> 
  </div>
  <div className="email d-flex">
  <img src="../images/email.webp" className="email-img"/>
  <div className="email-text">
  <h6>Email ID</h6>
  <p className="mb-0">housing.ap@gmail.com</p>
  </div> 
  </div>
  <div className="location d-flex">
  <img src="../images/location.webp" className="location-img"/>
  <div className="location-text">
  <h6>Location</h6>
  <p className="mb-0">Vijayawada</p>
  </div> 
  </div>
  </div>
  </div>
    </Col>
    </Row>
    </Container>
</section>
{/* ------------------------------------------ */}
{/* -----------Pradhana mantri Yojana--------- */}
<section id="padhan-mantri" className="p-0 bg-transparent">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1912.7181181219225!2d80.67426455168764!3d16.504060071746522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fad824353089%3A0xcbe0edefcf68f2d1!2sBSNL%20Telephone%20Exchange%2C%20Auto%20Nagar%2C%20Vijayawada!5e0!3m2!1sen!2sin!4v1729073895804!5m2!1sen!2sin" width="100%" height="500" style={{border:'0'}} className="border" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

</section>


{/* ----------------------------------------- */}
{/* ---------------Footer------------------- */}
<footer className="pt-5 position-relative footer-part">
<img src="../images/blue-bottom-img.webp" className="img-fluid blue-bottom-img"/>  
<Container className="footer-contain">
 <Row>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3} className="mb-4 mb-md-0">
  <div className="footer-content">
   <h5>Address</h5>
   <p className="adsress-text">AP State Housing Corporation<br></br>Plot No : 11 & 12 Behind BSNL,<br></br>Telephone Exchange Auto Nagar,<br></br>Vijayawada, Andhra Pradesh- 520007.</p> 
  
  </div>
  <ul className="social-media-icons">
  <li><a href="#"><TiSocialFacebook className="icony"/></a></li>
  <li><a href="#"><FaTwitter className="icony"/></a></li>
  <li><a href="#"><FaGoogle className="icony"/></a></li>
  <li><a href="#"><FaYoutube className="icony"/></a></li>
  <li><a href="#"><FaInstagram className="icony"/></a></li>
</ul>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Important <span>Links</span></h5>
  <ul>
  <li><a href="#">PMAY-GRAMIN</a></li>  
  <li><a href="#">PMAY-URBAN</a></li>  
  <li><a href="#">Beneficiary Search</a></li>  
  <li><a href="#">OFMS</a></li>  
  <li><a href="#">Tenders</a></li>  
  <li><a href="#">RTI - Andhra Pradesh</a></li>  
  <li><a href="#">RTI - Government of India</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Quick <span>Links</span></h5>
  <ul>
  <li><a href="#">Contact Us</a></li>  
  <li><a href="#">Gallery</a></li>  
  <li><a href="#">FAQ's</a></li>  
  <li><a href="#">News & Articles</a></li>  
  <li><a href="#">Signin / Login</a></li>  
  <li><a href="#">GO’s</a></li>  
  <li><a href="#">Circular's</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Get in <span>Touch</span></h5>
  <div className="phone d-flex">
  <img src="../images/phone.webp" className="phone-img"/>
  <div className="phone-text">
  <h6>Toll free Number</h6>
  <p>08663501300</p>
  </div> 
  </div>
  <div className="email d-flex">
  <img src="../images/email.webp" className="email-img"/>
  <div className="email-text">
  <h6>Email ID</h6>
  <p>housing.ap@gmail.com</p>
  </div> 
  </div>
  <div className="location d-flex">
  <img src="../images/location.webp" className="location-img"/>
  <div className="location-text">
  <h6>Location</h6>
  <p>Vijayawada</p>
  </div> 
  </div>
  </div>
  </Col>
  </Row>
  <hr className="mb-0"></hr>
  <Row className="pt-4 pb-3">
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom">
    <p>All Rights Reserved © 2024, APSHCL</p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom2">
    <p>Visitors Count : <span>850278</span></p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom3">
    <p>Design and Developed by</p>
    <a href="https://apcfss.in/" target="_blank"><img src="../images/apcfss.webp" className="brand-logo"/></a>
  </div>
  </Col>
 </Row> 
</Container>  
</footer>
</>

  )
}
export default Contact;